import Component from 'gia/Component';

import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(TextPlugin)
export default class Intro extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      counter: {},
      finalNumber: {}
    }

  }

  mount() {
    let that = this;
    let numbers = [
      0,
      2,
      5,
      10,
      50,
      120,
      300,
      400,
      800,
      1200,
      1380,
      2319,
      2389,
      2984,
      3000
    ];
    // let timeline = gsap.timeline({
    //   repeat:-1,
    //   repeatDelay:10
    // });
    // numbers.forEach((number, index) => {
    //   timeline.to(this.element, {
    //     duration: 0.1,
    //     text: number,
    //     ease: "none",
    //   });
    // });


    const querystring = window.location.search;
    const params = new URLSearchParams(querystring);

    let test = params.get('test'); // '42'


    let tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 10
    });

    gsap.utils.toArray(this.ref.counter).forEach(function(el) {
      var target = {val: 0};
      tl.to(target, {
        val: 2999,
        duration: 5,
        onUpdate: function() {
          // if (test == 3) {
          let colors = [
            'text-green',
            'text-yellow',
            'text-pink'
          ];
          var item = colors[Math.floor(Math.random() * colors.length)];

          el.innerHTML = target.val.toFixed(0).replace(3, "<span class=\"" + item + "\">3</span>");
          // } else {
          //   el.innerText = target.val.toFixed(0);
          // }
        },
        onStart: function() {
          that.ref.finalNumber.classList.add('hidden');
        },
        onComplete: function() {
          el.innerHTML = '';
          that.ref.finalNumber.classList.remove('hidden');
        }
      });
    });

    let tlColor = gsap.timeline({
      repeat: -1, yoyo: true
    });
    tlColor.to(that.ref.finalNumber, {
      color: '#f97373',
      duration:2
    },"+=2");
    tlColor.to(that.ref.finalNumber, {
      color: '#ffb600',
      duration:2
    },"+=2");
    tlColor.to(that.ref.finalNumber, {
      color: '#aaa1f8',
      duration:2
    },"+=2");
    tlColor.to(that.ref.finalNumber, {
      color: '#1b4134',
      duration:2
    },"+=2");


    // console.log(test);
    // if (test == 1) {
    //   let body = document.querySelector('body');
    //   let tl2 = gsap.timeline({
    //     repeat: -1, yoyo: true
    //   });
    //   tl2.to(body, {
    //     backgroundColor: '#ffb600',
    //     duration: 3
    //   }, "+=3");
    //   tl2.to(body, {
    //     backgroundColor: '#aaa1f8',
    //     duration: 3
    //   }, "+=3");
    //   tl2.to(body, {
    //     backgroundColor: '#1b4134',
    //     duration: 3
    //   }, "+=3");
    //   tl2.to(body, {
    //     backgroundColor: '#f97373',
    //     duration: 3
    //   }, "+=3");
    //   tl2.to(body, {
    //     backgroundColor: '#ffffff',
    //     duration: 3
    //   }, "+=3");
    // }
    //
    // if (test == 2) {
    //   let body = document.querySelector('body');
    //   let bottomTl = gsap.timeline({
    //     yoyo: true,
    //     scrollTrigger: {
    //       toggleActions: "play none none reverse",
    //       trigger: ".c--bottom",
    //       start: "top center"
    //     }
    //   });
    //   bottomTl.to(body, {
    //     backgroundColor: '#f97373',
    //     duration: 2
    //   });
    // }

  }


}